import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BuiltToLastInIndiana from "./sections/BuiltToLastInIndiana";
import TwoDecadesOfConcreteExcellence from "./sections/TwoDecadesOfConcreteExcellence";
import OurPavingSpectrum from "./sections/OurPavingSpectrum";
import TheDurabilityStandard from "./sections/TheDurabilityStandard";
import RecentWorkGallery from "./sections/RecentWorkGallery";
import Gallery from "./sections/Gallery";
import StoriesFromTheSlab from "./sections/StoriesFromTheSlab";
import Map from "./sections/Map";
import StartYourProject from "./sections/StartYourProject";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BuiltToLastInIndiana />
      <TwoDecadesOfConcreteExcellence />
      <OurPavingSpectrum />
      <TheDurabilityStandard />
      <RecentWorkGallery />
      <Gallery />
      <StoriesFromTheSlab />
      <Map />
      <StartYourProject />
      <Footer />
    </div>;
}